import {Component, OnInit, Injector, ElementRef, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {ScannerPrimarySearchList, ScannerSideListItems, ScannerChartingStudy, ScannerSide, getSideName, getStudyName} from '../interfaces/scanner.enums';
import {filter} from 'rxjs/operators';
import {ICHWizardResultRow, IESResultRow, IRsiResultRow, IBBResultRow, IMacdResultRow, IEmaResultRow, ITIWizardResultRow} from '../model/scanData';
import {BoxQuotaData} from '../../../model/box.quote.data';
import * as moment from "moment";
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";

import {quoteFilterTabsParams} from '../../quoteFilterTabs/quoteFilterTabs.list';
import {IchWizardpointType, IRSIScanRule, IBBandsScanRule, IEMAScanRule, IMACDScanRule, IEntrySignalsScanData, ScanHistory} from '../interfaces/scanner.interfaces';
import {ShowsaveScanComponentModal} from '../../modals/saveScan/saveScan.component';
import {showScannerTrialPopupModal} from '../modals/ScannerTrialPopup/show-ScannerTrialPopup-modal';
import {showScannerTrialReminderModal} from '../modals/ScannerTrialReminder/show-ScannerTrialReminder-modal';
import {showScannerTrialInfoImagesModal} from '../modals/ScannerTrialInfoImages/show-ScannerTrialInfoImages-modal';
import {showScannerAutoTrialModal} from '../modals/ScannerAutoTrial/show-ScannerAutoTrial-modal';
import {HistoryItemPeriod, getPeriodName} from '../../../interfaces/historyItem';
@Component({
    selector: 'app-scanner-Results',
    template: require('./scanner-Results.component.html'),
    styles: [require('./scanner-Results.component.scss')]
})
export class ScannerResultsComponent extends AppComponentBase implements OnInit {

    @Output("narrowScan")
    change: EventEmitter<boolean> = new EventEmitter<boolean>();

    narrowScan() {
        this.workspace.isNarrowScanMode = true;
        this.change.emit(true);
    }



    constructor(injector: Injector) {
        super(injector);

        this.workspace.globaGridMode.fullScreenScanerAction.subscribe(v => {

            if(v == "backFromNarrow") {
                this.workspace.isNarrowScanMode = false;
                this.exitNarrowList();
            }

            if(v == "newScan") {
                this.workspace.isNarrowScanMode = false;
                this.newScan();
            }

            if(v == "saveScan") {
                this.saveScan(this.activeNarrowScanner);
            }

        })
        // this.showNewScanScreen = true;

        this.workspace.appStoreData();

        this.globaGridMode.scannerReminderLauncher.subscribe(v => {
            console.log("TR-2");
            this.showTrialReminder()
        });

        this.workspace.globaGridMode.scanFinished.subscribe(v => {

            if(this.workspace.scanFinished==true)
            {
                return;
            }

            this.workspace.scanFinished = true
            this.workspace.scanInProgress = false;
            this.workspace.showScanResults = true;
            // this.filteredResults = [];
            this.scanRuleInformation = "";



            let instrument = this.workspace.selectedPrimaryScanner;

            if(this.workspace.processNarrowScan) {
                instrument = this.workspace.selectedPrimaryScanner_Narrow;
            }

            switch(instrument) {
                case ScannerPrimarySearchList.SCANNER_TIWIZARD:

                    this.scanRuleInformation = "";
                    this.filteredResults = this.resultsBoxesTI;



                    if(this.filteredResults.length == 0) {
                        this.noResults = true;
                    }
                    else {
                        this.noResults = false;
                        this.activateScrollBars();
                    }

                    break;

                case ScannerPrimarySearchList.SCANNER_WIZARD:

                    this.scanRuleInformation = "";
                    this.filteredResults = this.resultsBoxes;



                    if(this.filteredResults.length == 0) {
                        this.noResults = true;
                    }
                    else {
                        this.noResults = false;
                        this.activateScrollBars();
                    }

                    break;

                case ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS:
                    this.scanRuleInformation = "";

                    this.filteredResults = this.resultsBoxesES;


                    if(this.filteredResults.length == 0) {
                        this.noResults = true;
                    }
                    else {
                        this.noResults = false;

                        this.activateScrollBars();
                    }

                    break;


                case ScannerPrimarySearchList.SCANNER_CHARTING:
                    //  this.filteredResults = this.resultsCharting();

                    this.filteredResults = this.resultsCharting();
                    if(this.filteredResults.length == 0) {
                        this.noResults = true;
                    }
                    else {
                        this.noResults = false;

                        this.activateScrollBars();
                    }


                    break;


            }

            if(!this.workspace.processNarrowScan) {
                let lastRules = {
                    period: this.workspace.scannerSearch_period,
                    charting: this.workspace.scannerSearch_chartingstudy,
                    scanner: this.workspace.selectedPrimaryScanner,
                    rule:  JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule)),
                    market: this.workspace.scannerSearch_market,
                    filteredResults: this.filteredResults.map(v => {return v.Symbol})
                }

                this.searchDataRule = Object.assign({}, lastRules);
            }

            if(this.workspace.processNarrowScan) {
                let lastRules = {
                    period: this.workspace.scannerSearch_Narrow_period,
                    charting: this.workspace.scannerSearch_Narrow_chartingstudy,
                    scanner: this.workspace.selectedPrimaryScanner_Narrow,
                    rule:  JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule_Narrow)),
                    market: this.workspace.scannerSearch_market,
                    filteredResults: this.filteredResults.map(v => {return v.Symbol})
                }

                this.searchDataRule = Object.assign({}, lastRules);
            }

            this.activateScrollBars();


        })




        //  console.log("TR-1A" + this.workspace.userId + " " + this.daysToTrialEnd);

        this.globaGridMode.setPopScan.subscribe(v => {

            if(!this.workspace.scannerPopupShowedBySession) {
                setTimeout(() => {
                    if(this.daysToTrialEnd < 3 && this.daysToTrialEnd > -1000 && this.workspace.userId != 0) {
                        console.log("TR-1" + this.workspace.userId + " " + this.daysToTrialEnd);
                        if(!this.workspace.hasSomeProduct)
                            this.showTrialReminder()
                    }
                    else {
                        if(this.workspace.userId > 0 && !this.workspace.scannerPopupShowedBySession) {
                            this.showTrialInfo();
                            this.workspace.scannerPopupShowedBySession = true;
                        }

                    }
                    this.workspace.scannerPopupShowedBySession = true;
                    //  if(this.daysToTrialEnd>3 && this.daysToTrialEnd>-1000 && this.workspace.userId!=0)
                    //   {
                    console.log("AUTOTRIALPOPUPS")
                    //   }
                }, 1000);
            }
        })


        this.globaGridMode.registrationScanner.subscribe(v => {

            if(!this.workspace.scannerPopupShowedBySession) {
                this.showTrialInfo();
                this.workspace.scannerPopupShowedBySession = true;
            }

            this.showAutoTrial();
        })

        this.workspace.globaGridMode.updateScanList.subscribe(v => {
            this.setPrevList = true;
            console.log("LOADLISTDATA")
            console.log(this.workspace.selectedSavedScan);
            console.log(this.workspace.isNarrowScanMode);
            console.log(this.workspace.scanHistory);
            let lastListByKey = this.loadHistoryItems(this.workspace.selectedSavedScan, this.workspace.isNarrowScanMode);
            this.workspace.showScanResults = true;
            this.noResults = true;
            this.filteredResults = [];

            if(lastListByKey) {
                if(lastListByKey[0].length > 0) {

                    if(!this.workspace.isNarrowScanMode) {
                        this.workspace.scanResultList = Object.assign([], lastListByKey[0]).map((v: any) => {
                            let symbol = v.Symbol;
                            v.symbol = symbol;
                            return v;
                        });
                    }

                    this.filteredResults = Object.assign([], lastListByKey[0]);
                    this.savedDate = lastListByKey[1];
                    this.noResults = false;
                }
                else {
                    if(!this.workspace.isNarrowScanMode)
                        this.workspace.showScanResults = false;
                }

            }
            this.setPrevList = false;

        })

    }


    private _savedDate: any = undefined;
    public get savedDate(): any {
        return this._savedDate;
    }
    public set savedDate(value: any) {
        this._savedDate = value;
    }

    public loadHistoryItems(key: string, narrowMode: boolean) {
        try{

        
        let item = this.workspace.scanHistory.find(v => v.key == this.workspace.selectedSavedScan);
        let list: BoxQuotaData[] | undefined = [];
        let date: any;
        if(item) {


            if(narrowMode) {
                list = item.secondary
                date = item.secondaryDate
            }
            else {
                list = item.primary
                date = item.primaryDate
            }

        }


        if(!this.workspace.isNarrowScanMode) {
            let lastRules = {
                period: this.workspace.scannerSearch_period,
                charting: this.workspace.scannerSearch_chartingstudy,
                scanner: this.workspace.selectedPrimaryScanner,
                rule:  JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule)),
                market: this.workspace.scannerSearch_market,
                filteredResults: this.filteredResults.map(v => {return v.Symbol})
            }

            this.searchDataRule = Object.assign({}, lastRules);
        }

        if(this.workspace.isNarrowScanMode) {
            let lastRules = {
                period: this.workspace.scannerSearch_Narrow_period,
                charting: this.workspace.scannerSearch_Narrow_chartingstudy,
                scanner: this.workspace.selectedPrimaryScanner_Narrow,
                rule:  JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule_Narrow)),
                market: this.workspace.scannerSearch_market,
                filteredResults: this.filteredResults.map(v => {return v.Symbol})
            }

            this.searchDataRule = Object.assign({}, lastRules);
        }






        return [list, date];
        }
        catch(e)
        {
            console.log(e);
            return [];
        }
    }


    public getScanInfo()
    {

    }


    public addNewHistoryItem(key: string, list: BoxQuotaData[], narrowMode: boolean, searchDataRule?:any) {

        if(!narrowMode) {
            this.workspace.scanHistory.push(
                {
                    key: this.workspace.selectedSavedScan,
                    primary: list,
                    primaryDate: this.today,
                    primaryRule:searchDataRule
                })
        }
        else {
            this.workspace.scanHistory.push(
                {
                    key: this.workspace.selectedSavedScan,
                    secondary: list,
                    secondaryDate: this.today,
                    secondaryRule:searchDataRule
                })
        }

    }

    public updateHistoryItem(key: string, list: BoxQuotaData[], narrowMode: boolean, searchDataRule?:any) {

        let update = this.workspace.scanHistory.find(v => v.key == this.workspace.selectedSavedScan);

        if(update) {
            if(!narrowMode) {
                update.primary = list;
                update.primaryDate = this.today;

                if(!this.setPrevList)
                update.primaryRule = searchDataRule
            }
            else {
                update.secondary = list;
                update.secondaryDate = this.today;

                if(!this.setPrevList)
                update.secondaryRule = searchDataRule
            }
        }


    }










    public activateScrollBars() {

        $(".results-container").mCustomScrollbar({
            axis: "y",
            theme: "inset-3", // "minimal-dark",
            scrollbarPosition: "outside",
            alwaysShowScrollbar: 0, // 0,1,2
            scrollButtons: {
                enable: true
            },
            mouseWheel: {
                enable: true,
                scrollAmount: 75
            }
        });

        $(".narrow-container").mCustomScrollbar({
            axis: "y",
            theme: "inset-3", // "minimal-dark",
            scrollbarPosition: "outside",
            alwaysShowScrollbar: 0, // 0,1,2
            scrollButtons: {
                enable: true
            },
            mouseWheel: {
                enable: true,
                scrollAmount: 75
            }
        });

    }






    private _searchDataRule: any;
    public set searchDataRule(v: any) {
        this._searchDataRule = v;
    }

    public get searchDataRule(): any {
        return this._searchDataRule;
    }


    private _noResults: boolean = true;
    public get noResults(): boolean {
        return this.workspace.noResults;
    }
    public set noResults(value: boolean) {
        this.workspace.noResults = value;
    }

    public get today() {
        return moment(new Date()).format('LLLL');
    }

    public get resultsBoxes(): BoxQuotaData[] {
        let filterIndex = this.filter_SCANNER_WIZARD();
        let boxes = this.workspace.boxes.filter((v) => {
            return filterIndex.indexOf(v.Symbol) > -1;
        })
        return boxes;
    }

    public get resultsBoxesTI(): BoxQuotaData[] {



        // let filterIndex = this.filter_SCANNER_WIZARD();
        let resultSymbols: string[] = [];
        if(!this.workspace.processNarrowScan)
            resultSymbols = this.workspace.scanResultList.map(v => {return v.symbol});

        if(this.workspace.processNarrowScan)
            resultSymbols = this.workspace.scanResultListNarrow.map(v => {return v.symbol});


        let boxes = this.workspace.boxes.filter((v) => {
            return resultSymbols.indexOf(v.Symbol) > -1;
        })
        return boxes;
    }

    public trackByFn(index: number, item: BoxQuotaData) {
        return item.Symbol;
    }

    public scanRuleInformation: string = "";

    public filter_SCANNER_WIZARD() {


        let filtered: any[] = [];
        let marketInfo: string = "";
        let sideInfo: string = "";
        if(!this.workspace.processNarrowScan) {


            filtered = this.workspace.scanResultList.filter((v: ICHWizardResultRow) => {
                return v.value == this.workspace.scannerCurrentRule.selectedPoints
            }).map(v => {
                return v.symbol;
            })

            marketInfo = (quoteFilterTabsParams() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_market
            })[0].label

            sideInfo = (ScannerSideListItems() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_side
            })[0].label


            this.scanRuleInformation = marketInfo + " " + sideInfo;
            //marketInfo.
        }

        if(this.workspace.processNarrowScan) {
            filtered = this.workspace.scanResultListNarrow.filter((v: ICHWizardResultRow) => {
                return v.value == this.workspace.scannerCurrentRule_Narrow.selectedPoints
            }).map(v => {
                return v.symbol;
            })

            marketInfo = (quoteFilterTabsParams() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_market
            })[0].label

            sideInfo = (ScannerSideListItems() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_Narrow_side
            })[0].label
        }

        if(!this.workspace.processNarrowScan) {
            this.workspace.scanResultList = [];
            filtered.forEach((v: any) => {
                this.workspace.scanResultList.push({symbol: v})
            });
        }


        return filtered
    }


    public get resultsBoxesES(): BoxQuotaData[] {

        let filterIndex = this.filter_SCANNER_ENTRYSIGNALS();

        let boxes = this.workspace.boxes.filter((v) => {
            return filterIndex.indexOf(v.Symbol) > -1;
        })
        return boxes;
    }


    public filter_SCANNER_ENTRYSIGNALS() {

        let filtered: any;
        if(!this.workspace.processNarrowScan) {


            let pattern = [this.workspace.scannerCurrentRule.LData.direction,
            this.workspace.scannerCurrentRule.MData.direction,
            this.workspace.scannerCurrentRule.SData.direction,
            this.workspace.scannerCurrentRule.EData.direction
            ];



            filtered = this.workspace.scanResultList.filter((v: IESResultRow) => {

                if(pattern[0] == undefined) {
                    v.value[0] = undefined
                }
                if(pattern[1] == undefined) {
                    v.value[1] = undefined
                }
                if(pattern[2] == undefined) {
                    v.value[2] = undefined
                }
                if(pattern[3] == undefined) {
                    v.value[3] = undefined
                }



                return JSON.stringify(v.value) == JSON.stringify(pattern)


            }).map(v => {
                return v.symbol;
            })

            let marketInfo = (quoteFilterTabsParams() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_market
            })[0].label

            this.scanRuleInformation = marketInfo
        }


        if(this.workspace.processNarrowScan) {



            let pattern = [this.workspace.scannerCurrentRule_Narrow.LData.direction,
            this.workspace.scannerCurrentRule_Narrow.MData.direction,
            this.workspace.scannerCurrentRule_Narrow.SData.direction,
            this.workspace.scannerCurrentRule_Narrow.EData.direction
            ];



            filtered = this.workspace.scanResultListNarrow.filter((v: IESResultRow) => {

                if(pattern[0] == undefined) {
                    v.value[0] = undefined
                }
                if(pattern[1] == undefined) {
                    v.value[1] = undefined
                }
                if(pattern[2] == undefined) {
                    v.value[2] = undefined
                }
                if(pattern[3] == undefined) {
                    v.value[3] = undefined
                }



                return JSON.stringify(v.value) == JSON.stringify(pattern)


            }).map(v => {
                return v.symbol;
            })

            let marketInfo = (quoteFilterTabsParams() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_market
            })[0].label

            this.scanRuleInformation = marketInfo
        }

        if(!this.workspace.processNarrowScan) {
            this.workspace.scanResultList = [];
            filtered.forEach((v: any) => {
                this.workspace.scanResultList.push({symbol: v})
            });
        }

        //  this.workspace.scanResultList = this.workspace.scanResultList.filter((v)=>{
        // return filtered.indexOf(v.Symbol)>-1;
        //  });


        return filtered;
    }






    private _filteredResults: BoxQuotaData[] = [];
    public get filteredResults(): BoxQuotaData[] {
        return this._filteredResults;
    }

    private _scanHistoryForNonSaved: ScanHistory = {key:'No_Saved'};
    public get scanHistoryForNonSaved(): ScanHistory {
        return this._scanHistoryForNonSaved;
    }
    public set scanHistoryForNonSaved(value: ScanHistory) {
        this._scanHistoryForNonSaved = value;
    }


    public set filteredResults(value: BoxQuotaData[]) {
        this._filteredResults = value;
          console.log("SAVELISTDATA")
          console.log(value);
        this.exitNarrow = false;
        this.savedDate = undefined;
        let lastRules = {}
        if(value.length > 0) {
          
            console.log(this.workspace.selectedSavedScan);
            console.log(this.workspace.isNarrowScanMode);
            console.log(value);
          //  this.searchDataRule;
            let history = this.workspace.scanHistory.find(v => v.key == this.workspace.selectedSavedScan);

            if(!this.workspace.isNarrowScanMode) {
                lastRules = {
                    period: this.workspace.scannerSearch_period,
                    charting: this.workspace.scannerSearch_chartingstudy,
                    scanner: this.workspace.selectedPrimaryScanner,
                    rule: JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule)),
                    market: this.workspace.scannerSearch_market,
                    filteredResults: Object.assign([], value)
                }
            }
            else
            {
                lastRules = {
                    period: this.workspace.scannerSearch_Narrow_period,
                    charting: this.workspace.scannerSearch_Narrow_chartingstudy,
                    scanner: this.workspace.selectedPrimaryScanner_Narrow,
                    rule:  JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule_Narrow)),
                    market: this.workspace.scannerSearch_market,
                    filteredResults: Object.assign([], value)
                }
            }

            
            if(this.workspace.selectedSavedScan && history == undefined) {

               
                this.addNewHistoryItem(this.workspace.selectedSavedScan, Object.assign([], value), this.workspace.isNarrowScanMode, Object.assign([], lastRules) )

            }
            else if(this.workspace.selectedSavedScan && history != undefined) {
                this.updateHistoryItem(this.workspace.selectedSavedScan, Object.assign([], value), this.workspace.isNarrowScanMode, Object.assign([], lastRules))
            }
            else
            {
                console.log("SCANFORNEW");

                if(!this.setPrevList)
                {

                
                    if(!this.workspace.isNarrowScanMode) {

                        // lastRules = {
                        //     period: this.workspace.scannerSearch_period,
                        //     charting: this.workspace.scannerSearch_chartingstudy,
                        //     scanner: this.workspace.selectedPrimaryScanner,
                        //     rule: JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule)),
                        //     market: this.workspace.scannerSearch_market,
                        //     filteredResults: Object.assign([], value)
                        // }

                        this.scanHistoryForNonSaved.primary = {...value}
                        this.scanHistoryForNonSaved.primaryRule =  {...lastRules}
                        
                    }
                    else {
                        // lastRules = {
                        //     period: this.workspace.scannerSearch_Narrow_period,
                        //     charting: this.workspace.scannerSearch_Narrow_chartingstudy,
                        //     scanner: this.workspace.selectedPrimaryScanner_Narrow,
                        //     rule:  JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule_Narrow)),
                        //     market: this.workspace.scannerSearch_market,
                        //     filteredResults: Object.assign([], value)
                        // }
                        this.scanHistoryForNonSaved.secondary = {...value}
                        this.scanHistoryForNonSaved.secondaryRule = {...lastRules}
                    }
                   
                }
            }
        }
        else
        {
            this.scanHistoryForNonSaved.secondaryRule = {key:'No_Saved'};
        }

    }

    public get scanDetails()
    {
        if(this.workspace.selectedSavedScan)
        {
            let history = this.workspace.scanHistory.find(v => v.key == this.workspace.selectedSavedScan);

            if(history)
            {
                if(!this.workspace.isNarrowScanMode)
                {
                    return {firstLevel: this.procesScanDetails(history.primaryRule), secondLevel:null}
                }
                else
                {
                    return {firstLevel: this.procesScanDetails(history.primaryRule), secondLevel: this.procesScanDetails(history.secondaryRule)}
                }
            }
        }
        else
        {
            if(!this.workspace.isNarrowScanMode)
            {
                return {firstLevel: this.procesScanDetails(this.scanHistoryForNonSaved.primaryRule), secondLevel:null}
            }
            else
            {
                return {firstLevel: this.procesScanDetails(this.scanHistoryForNonSaved.primaryRule), secondLevel: this.procesScanDetails(this.scanHistoryForNonSaved.secondaryRule)}
            }
        }

        return {firstLevel:null, secondLevel:null};
    }


    public procesScanDetails(data:any)
    {
        if(data)
        {
            switch (data.scanner)
            {
                case ScannerPrimarySearchList.SCANNER_WIZARD:
                    return "WIZARD" + " " + getPeriodName(data.period) + ", " + getSideName(data.rule.side) + ", points: " + data.rule.selectedPoints.toString();
                break;

                case ScannerPrimarySearchList.SCANNER_CHARTING:
                        return "Charting" + ", " + getStudyName(data.charting) + ", " + getPeriodName(data.period);
                        return "charting";
                break;

                case ScannerPrimarySearchList.SCANNER_TIWIZARD:
                        return "TI WIZARD" + " " + getPeriodName(data.period);
                        return "tiwizard";
                break;

                case ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS:

                    let strData =   this.getDirectionStr(data.rule.LData.direction) + " " + getPeriodName(data.rule.LData.period) + " | " +
                                    this.getDirectionStr(data.rule.MData.direction) + " " + getPeriodName(data.rule.MData.period) + " | " +
                                    this.getDirectionStr(data.rule.SData.direction) + " " + getPeriodName(data.rule.SData.period) + " | " +
                                    this.getDirectionStr(data.rule.EData.direction) + " " + getPeriodName(data.rule.EData.period);

                        return "Entry Signals |" + " " + strData;
                        return "entrysignals";
                break;
            }
        }
        return null;
    }


    public getDirectionStr(val:any)
    {
        if(val==1)
        {
            return "↑"
        }

        if(val == -1)
        {
            return "↓"
        }

        return "NA"
    }



    private _setPrevList: boolean = false;
    public get setPrevList(): boolean {
        return this._setPrevList;
    }
    public set setPrevList(value: boolean) {
        this._setPrevList = value;
    }

    private _activeNarrowScanner = false;
    public get activeNarrowScanner() {
        return this._activeNarrowScanner;
    }
    public set activeNarrowScanner(value) {

    //    this.setPrevList = true;
        let avaiability = this.workspace.checkAvaiabilityofComponent("activeNarrowScanner");

        if(avaiability || value == false) {
            this._activeNarrowScanner = value;

            if(value != false) {
                
                this.narrowScan()
                let lastListByKey = this.loadHistoryItems(this.workspace.selectedSavedScan, this.workspace.isNarrowScanMode);
                this.filteredResults = Object.assign([], lastListByKey[0]);
                this.savedDate = lastListByKey[1];
               
            }
            ;


        }
        else {
            this._activeNarrowScanner = false;

            showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode).modalType = "narrowScanner";

        }

      //  this.setPrevList = false;
        this.workspace.AppTick();

    }




    ngOnInit() {

    }

    public get allowAccess(): boolean {
        return this.workspace.allowScannerAccess;
    }

    public get activateUrl() {
        return this.workspace.subscribeHref;
    }

    public get trialExpired(): boolean {
        return this.workspace.isTrialExpired;
    }


    public get hasSomeProduct(): boolean {
        return this.workspace.hasSomeProduct;
    }

    public jumpToActivate() {

        if(this.workspace.trialDaysToEnd <= 0 && this.workspace.trialDateRanges != undefined) {

            if(!this.hasSomeProduct) {
                showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode);
            }
            else {
                showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode);
            }

            return;
        }



        if(!this.workspace.allowScannerAccess && this.workspace.allowScannerTrial) {

            if(this.workspace.mobileMode=="desktop" || this.dataService.AllowScannerMobile)
            showScannerTrialPopupModal(this.modalService, this.workspace, this.workspace.mobileMode);
            
        }



        // if(this.workspace.allowScannerAccess)
        // {

        // }



    }

    get simulatedScannedCount()
    {
        const now = new Date().getTime();
        return Math.floor((now-this.workspace.scanStartTime)/130);
    }

    get scannedCount()
    {
        if(this.workspace.scannedCount == 0)
            return this.simulatedScannedCount;

        return Math.min(this.workspace.scannedCount, this.simulatedScannedCount);
    }


    public get scanInProgress(): boolean {
        return this.workspace.scanInProgress || this.simulatedScannedCount < this.workspace.currentCountToScan;
    }


    public selectPrimarySearch(value: ScannerPrimarySearchList) {

        this.workspace.selectedPrimaryScanner = value;


    }

    public ScannerPrimarySearchList = ScannerPrimarySearchList;


    public resultsCharting() {




        let filtered: any[] = [];
        let boxes: any;
        if(!this.workspace.processNarrowScan) {
            filtered = this.workspace.scanResultList.map(v => {
                return v.symbol;
            })


            boxes = this.workspace.boxes.filter((v) => {
                return filtered.indexOf(v.Symbol) > -1;
            })



            let marketInfo = (quoteFilterTabsParams() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_market
            })[0].label

            let sideInfo = (ScannerSideListItems() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_side
            })[0].label

            this.scanRuleInformation = marketInfo + " " + sideInfo;

        }

        if(this.workspace.processNarrowScan) {
            filtered = this.workspace.scanResultListNarrow.map(v => {
                return v.symbol;
            })


            boxes = this.workspace.boxes.filter((v) => {
                return filtered.indexOf(v.Symbol) > -1;
            })

            let marketInfo = "";

            let marketInfoPOS = (quoteFilterTabsParams() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_market
            })[0];

            if(marketInfoPOS) {
                marketInfo = marketInfoPOS.label
            }


            let sideInfoPOS = (ScannerSideListItems() as {id: string, label: string}[]).filter(v => {
                return v.id == this.workspace.scannerSearch_side
            })[0]


            let sideInfo = "";
            if(sideInfoPOS) {
                sideInfo = sideInfoPOS.label
            }


            this.scanRuleInformation = marketInfo + " " + sideInfo;
        }


        return boxes;
    }

    private _showNewScanScreen: boolean = true;
    public get showNewScanScreen(): boolean {
        return this._showNewScanScreen;
    }
    public set showNewScanScreen(value: boolean) {
        this._showNewScanScreen = value;
    }


    public newScan() {
        this.showNewScanScreen = true;
        this.workspace.showScanButton = false;
        this.showSavedStrategies = false;
        this.workspace.scanResultList = [];
        this.workspace.scannerSearch_period = HistoryItemPeriod.Min1;
        this.workspace.scannerSearch_chartingstudy = ScannerChartingStudy.SCANNER_RSI;
        this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
        this.workspace.scannerCurrentRule = [];
        this.workspace.canShowScannerSearchForm = true;
        this.workspace.showScanResults = false;
        this.workspace.scanFinished = false;
        this.workspace.allowScanProcess = false;
        this.activeNarrowScanner = false;
        this.workspace.scannerSearch_Narrow_period = HistoryItemPeriod.Min1;
        this.workspace.scannerSearch_Narrow_chartingstudy = ScannerChartingStudy.SCANNER_RSI;
        this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
        this.workspace.scannerCurrentRule_Narrow = [];
        this.workspace.narrowscanFinished = false;
        this.workspace.narrowScanComponent = ScannerPrimarySearchList.SCANNER_NA;
        this.workspace.selectedSavedScan = "";
        this.workspace.showBackToResults = false;
    }

    public newScanProcess() {
        this.newScan();
        this.showNewScanScreen = false;
        //  this.workspace.showScanButton = true;
    }

    public saveScan(narrow: boolean) {
        ShowsaveScanComponentModal(this.modalService, narrow);

        return;

    }
    private _showSavedStrategies: boolean = false;
    public get showSavedStrategies(): boolean {
        return this._showSavedStrategies;
    }
    public set showSavedStrategies(value: boolean) {
        this._showSavedStrategies = value;
        this.workspace.showScanButton = value;
    }
    public saveScanShow() {
        this.newScan();
        this.showSavedStrategies = true;
        this.showNewScanScreen = false;
    }


    public finishProcess() {
        // this.workspace.currentCountToScan = this.workspace.scannedCount;
        // console.log(this.workspace.scanResultList);
        // this.workspace.scanFinished = true;
        // this.workspace.scanInProgress = false;
        // this.workspace.showScanResults = true;
        // this.workspace.scannedCount = 0;
        console.log("HARD FINISH");
        console.log(this.workspace.scanResultList);
        this.workspace.scannedCount = this.workspace.currentCountToScan;
        this.workspace.hardFinish = true;
        this.workspace.globaGridMode.scanFinished.next(1)
    }

    private _exitNarrow: boolean = false;
    public get exitNarrow(): boolean {
        return this._exitNarrow;
    }
    public set exitNarrow(value: boolean) {
        this._exitNarrow = value;
    }

    public exitNarrowList() {

        //  this.exitNarrow = true;
        this.setPrevList = true;
        let filtered = this.workspace.scanResultList.map(v => {
            return v.symbol;
        })


        let boxes = this.workspace.boxes.filter((v) => {
            return filtered.indexOf(v.Symbol) > -1;
        })


        let lastRules = {
            period: this.workspace.scannerSearch_period,
            charting: this.workspace.scannerSearch_chartingstudy,
            scanner: this.workspace.selectedPrimaryScanner,
            rule:  JSON.parse(JSON.stringify(this.workspace.scannerCurrentRule)),
            market: this.workspace.scannerSearch_market,
            filteredResults: this.filteredResults.map(v => {return v.Symbol})
        }

        this.searchDataRule = Object.assign({}, lastRules);



        this.filteredResults = boxes;
        this.workspace.scanResultListNarrow = [];
        this.noResults = false;
        this.workspace.narrowscanFinished = false;
        this.activeNarrowScanner = false;
        this.scanHistoryForNonSaved.secondaryRule = {}
        this.setPrevList = false;
    }

    public get narrowScanFinished(): boolean {
        //return this._narrowScanFinished;
        return this.workspace.narrowscanFinished
    }


    public calculateScale() {
        let w = this.panelWidth;
        let unit = 1430;

        let scale = w / unit;
        return {
            transform: "scale(" + scale + ")"
        };
    }

    get panelWidth() {
        if(this.resultContainer !== undefined) {
            return this.resultContainer.nativeElement.offsetWidth || 476;
        } else {
            return 476;
        }
    }

    @ViewChild("scannerFullContainer") public resultContainer!: ElementRef;

    public get daysToTrialEnd() {
        return this.workspace.trialDaysToEnd;
    }


    public showTrialReminder() {


        if(!this.workspace.hasSomeProduct) {
            showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode);
        }
        else {
            showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode).modalType = "hasSomeProduct";
        }
    }


    public showTrialInfo() {
        let ac = this.workspace.cookieService.getCookie("scannerInfoDontshow");

        if(ac != "1") {

            if(this.workspace.mobileMode=="desktop" || this.dataService.AllowScannerMobile)
            showScannerTrialInfoImagesModal(this.modalService, this.workspace.mobileMode);

        }

    }

    public showTrialInfoNow()
    {
        showScannerTrialInfoImagesModal(this.modalService, this.workspace.mobileMode,true);
    }



    public showAutoTrial() {

        if(this.workspace.mobileMode=="desktop")
        showScannerAutoTrialModal(this.modalService, this.workspace.mobileMode);

    }
}
